import React from 'react';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import AppTab from './AppTab';

const appTabTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const index = props.findAppTab(overId);
      props.moveAppTab(draggedId, index);
    }
  },
};

const appTabSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findAppTab(props.id),
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      props.moveAppTab(droppedId, originalIndex);
    }
  },
};

@DropTarget('appTab', appTabTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('appTab', appTabSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
class DraggableAppTab extends AppTab {
  render() {
    const { connectDragSource, connectDropTarget, ...props } = this.props;
    return (
      connectDragSource
      && connectDropTarget
      && connectDragSource(connectDropTarget(super.render()))
    );
  }
}

export default DraggableAppTab;
